module.exports = __webpack_public_path__ + "img/busca-tematica-esp-marinas.6421fcb1.jpg";